// assets/js/controllers/preview_controller.ts
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['input', 'preview'];

    declare readonly inputTarget: HTMLInputElement;
    declare readonly previewTarget: HTMLImageElement;

    previewImage(event: Event) {
        const input = event.target as HTMLInputElement;

        if (!input.files || input.files.length === 0) {
            return;
        }

        const file = input.files[0];

        if (!file.type.startsWith('image/')) {
            return;
        }

        const reader = new FileReader();

        reader.onload = (e: ProgressEvent<FileReader>) => {
            if (e.target && typeof e.target.result === 'string') {
                this.previewTarget.src = e.target.result;
            }
        };

        reader.readAsDataURL(file);
    }
}
